import { useSecurityTypeClassification } from './useSecurityTypeClassification';
import { useLiquidityFilters } from './useLiquidityFilters';
import { useEsgMandateScreens } from './useEsgMandateScreens';

export function useEligibilityRules(
  geographicScope: Array<string>,
  cyclicality: Array<string>,
  coverageLabel?: string,
) {
  const securityType = useSecurityTypeClassification(
    geographicScope,
    cyclicality,
    coverageLabel,
  );
  const liquidity = useLiquidityFilters();
  const esgMandate = useEsgMandateScreens();

  return { securityType, liquidity, esgMandate };
}
